import { defineRecipe } from '@chakra-ui/react'

export const sibHeaderRecipe = defineRecipe({
  className: 'sib-header',
  base: {
    position: 'sticky',
    top: 0,
    // 'docked' (10) keeps the header above page content but below every overlay
    // layer. The 'sticky' token (1100) would sit above zIndex.dropdown (1000),
    // which renders menus opened from the header behind the header itself.
    zIndex: 'docked',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '4',
    paddingInline: '4',
    background: 'bg.subtle',
    borderBottomWidth: '2px',
    borderBottomColor: 'bg.muted',
    boxShadow: 'sm',
  },
})
